import { NgModule } from '@angular/core';
import { PlatformHeaderNavPanelComponentFacade } from './platform-header-nav-panel-component.facade';
import { DefinitionsDomainModule } from '~/modules/definitions/domain/definitions-domain.module';

@NgModule({
  imports: [DefinitionsDomainModule],
  providers: [PlatformHeaderNavPanelComponentFacade],
})
export class PlatformHeaderNavPanelComponentModule {}
